import { ChevronRight, ImagePlus } from 'lucide-react';

export const Chemin = ({ c, teinte, testId }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-3" data-testid={testId}>
    <p className={`text-xs font-bold ${teinte.texte}`}>{c.titre}</p>
    <div className="mt-2 flex flex-wrap items-center gap-1.5">
      {c.etapes.map((e, k) => (
        <span key={e} className="flex items-center gap-1.5">
          <span className={`rounded-lg px-2.5 py-1 text-xs font-medium text-[#0F172A] ${teinte.clair}`}>{e}</span>
          {k < c.etapes.length - 1 && <ChevronRight className={`h-4 w-4 shrink-0 ${teinte.texte}`} />}
        </span>
      ))}
    </div>
  </div>
);

const Repere = ({ n, teinte }) => (
  <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-white ${teinte.fort}`}>{n}</span>
);

export const Ecran = ({ s, teinte, testId }) => (
  <div className="grid gap-4 md:grid-cols-[minmax(0,300px)_1fr]" data-testid={testId}>
    <div className="rounded-[2rem] border-[6px] border-[#0F172A] bg-white p-3 shadow-lg">
      <p className="mb-2 text-center text-[10px] font-semibold uppercase tracking-widest text-slate-400">{s.titre}</p>
      <div className="space-y-1.5">
        {s.ecran.map((ligne) => (
          <div key={ligne.map(([t]) => t).join('|')} className="flex gap-1.5">
            {ligne.map(([t, n]) => (
              <span key={t} className={`flex min-w-[4rem] flex-auto items-center justify-between gap-1 rounded-lg px-2 py-1.5 text-[11px] leading-tight text-slate-700 ${n ? 'bg-slate-100 ring-1 ring-slate-300' : 'bg-slate-50'}`}>
                <span className="min-w-0 break-words">{t}</span>{n && <Repere n={n} teinte={teinte} />}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
    <ul className="space-y-2 self-center">
      {s.legende.map(([n, t]) => <li key={n} className="flex gap-2.5 text-sm text-slate-700"><Repere n={n} teinte={teinte} /><span>{t}</span></li>)}
    </ul>
  </div>
);

export const Captures = ({ items }) => (
  <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
    {items.map((c, k) => (
      <div key={c.titre} className="flex min-h-[150px] flex-col rounded-xl border-2 border-dashed border-slate-300 bg-slate-50/60 p-3" data-testid={`guide-capture-${k}`}>
        <p className="text-xs font-bold text-[#0F172A]">{c.titre}</p>
        <div className="flex flex-1 flex-col items-center justify-center py-3 text-slate-400">
          <ImagePlus className="h-6 w-6" /><span className="mt-1 text-xs italic">Collez votre capture ici</span>
        </div>
        <p className="text-[11px] text-slate-500">{c.texte}</p>
      </div>
    ))}
  </div>
);
